import React from 'react'
import PropTypes from 'prop-types'

import { Modal } from 'Components/Modal'
import { ModalBody } from 'Components/Modal/ModalBody'
import { ModalFooter } from 'Components/Modal/ModalFooter'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { ModalTitle } from 'Components/Modal/ModalTitle'
import SubmitButton from 'Components/Form/SubmitButton'

export const ModalConfirmation = ({
  handleCancel,
  handleConfirm,
  modalShow,
  title,
  text,
  withoutText,
  labelCancel,
  labelConfirm,
  children,
  closeButton = true,
}) => {
  return (
    <Modal show={modalShow} onHide={handleCancel}>
      <ModalHeader closeButton={closeButton}>
        <ModalTitle>{title}</ModalTitle>
      </ModalHeader>
      <ModalBody>
        {withoutText ? null : text}
        {children}
      </ModalBody>
      <ModalFooter>
        <SubmitButton
          value="cancel"
          label={labelCancel}
          onClick={handleCancel}
        />
        <SubmitButton value={labelConfirm} onClick={handleConfirm} />
      </ModalFooter>
    </Modal>
  )
}

ModalConfirmation.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  modalShow: PropTypes.bool,
  title: PropTypes.string,
  withoutText: PropTypes.bool,
  text: PropTypes.string,
  labelCancel: PropTypes.string,
  labelConfirm: PropTypes.string,
}

ModalConfirmation.defaultProps = {
  withoutText: false,
  title: 'Warning',
  text: 'Are you sure?',
  labelConfirm: 'Save',
  labelCancel: 'Cancel',
}
